export default __webpack_public_path__ + "sign-in.png";